export default __webpack_public_path__ + "static/media/gold.2ce0f07d.svg";